import { Component, computed, input, Input, Signal, inject } from '@angular/core';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { Card, CardBlockReason, CardType } from '../../../../../_interfaces/cards.interface';
import { OffcanvasBaseComponent } from '../../../offcanvas/offcanvas-base/offcanvas-base.component';
import { VirtualCardStaticComponent } from '../../virtual-card-static/virtual-card-static.component';

@Component({
  selector: 'app-block-confirmation',
  imports: [OffcanvasBaseComponent, VirtualCardStaticComponent],
  templateUrl: './block-confirmation.component.html',
})
export class BlockConfirmationComponent {
  readonly offcanvasService = inject(OffcanvasService);

  cardDetail = input.required<Card>();
  protected readonly CardType = CardType;
  @Input({ required: true }) title: string | undefined;

  protected returnUrl: Signal<string> = computed<string>(() => {
    if (this.cardDetail().type === CardType.Personal) return '/cards/employee-cards';
    if (this.cardDetail().type === CardType.Subscription) return '/cards/subscription-cards';
    return '';
  });

  protected isReasonOther: Signal<boolean> = computed<boolean>(
    () => this.cardDetail().block?.block_reason === CardBlockReason.Other,
  );

  goToCardDetail() {
    this.offcanvasService.offCanvasNavigate(`${this.returnUrl()}/view/${this.cardDetail().id}`);
  }

  goToReplaceCard() {
    this.offcanvasService.offCanvasNavigate(`${this.returnUrl()}/replace-card/${this.cardDetail().id}`);
  }

  goToRemoveCard() {
    this.offcanvasService.offCanvasNavigate(`${this.returnUrl()}/remove-card/${this.cardDetail().id}`);
  }
}
